import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventV2Dto } from 'src/app/api/exa';
import { WeighingFuelService } from 'src/app/services/weighing-fuel.service';

@Component({
  selector: 'app-fuel-add-dialog',
  templateUrl: './fuel-add-dialog.component.html',
  styleUrls: ['./fuel-add-dialog.component.scss'],
})
export class FuelAddDialogComponent implements OnInit {
  @Input() username;
  @Input() latitude;
  @Input() longitude;
  @Input() machineId;
  @Input() owner;
  @Input() type;

  time = new Date().getTime();

  fuel: string = '';

  constructor(
    public modalCtrl: ModalController,
    private weight: WeighingFuelService
  ) {}

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  onClickCancel() {
    this.dismiss();
    // this.weight.getLocs();
  }

  onClickSave() {
    const refueling: EventV2Dto = {
      data: this.fuel,
      employee: this.username,
      latitude: this.latitude,
      longitude: this.longitude,
      machine: this.machineId,
      owner: this.owner,
      time: this.time.toString(),
      type: this.type,
    };
    console.log(refueling);
    //poner el evento cuando tenga acceso al backend
    this.dismiss();
  }
}
